import React from 'react';
import '../styles/PrivacyPolicy.css';
import Footer from "../components/Footer";
import Header from "../components/Header";
const PrivacyPolicy = () => {
  return (
    <div>
    <Header/>
    <div className="privacy-container">

      <h1>Privacy Policy & Terms of Use</h1>

      <section>
        <h2>1. Introduction</h2>
        <p>
          CyberKon is committed to protecting your privacy and ensuring a secure user experience. This document outlines how we collect, use, and safeguard your information, as well as your responsibilities when using our services.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>
          We may collect personal information such as your name, email address, and phone number when you contact us or use certain features of our platform. Additionally, we collect non-personal data such as usage statistics and technical logs.
        </p>
      </section>

      <section>
        <h2>3. Use of Information</h2>
        <p>
          The information we collect is used to improve our services, communicate with users, provide support, and enhance the functionality of our construction estimation tools.
        </p>
      </section>

      <section>
        <h2>4. Data Protection</h2>
        <p>
          We implement appropriate security measures to protect your data from unauthorized access, disclosure, or alteration. However, we advise users to also take precautions when sharing personal information online.
        </p>
      </section>

      <section>
        <h2>5. User Responsibilities</h2>
        <p>
          By using our services, you agree not to misuse, distribute, or copy proprietary features. You are responsible for the accuracy of the data you input into our estimation tools.
        </p>
      </section>

      <section>
        <h2>6. Third-party Services</h2>
        <p>
          Our platform may contain links to third-party websites. We are not responsible for their privacy practices or content. We recommend reviewing their policies before sharing any personal data.
        </p>
      </section>

      <section>
        <h2>7. Changes to Policy</h2>
        <p>
          We reserve the right to update this privacy policy and terms of use. Any changes will be posted on this page. Continued use of our platform constitutes acceptance of those changes.
        </p>
      </section>

      <section>
        <h2>8. Contact</h2>
        <p>
          For questions about this policy or your data, please contact us at: <a href="mailto:info@cyberkonstruct.com">info@cyberkon.com</a>
        </p>
      </section>
    </div>
    <Footer/>
    </div>
  );
};

export default PrivacyPolicy;
